import Vouchers from './Vouchers';

export default Vouchers;
